export default __webpack_public_path__ + "static/media/690.f4595f18.png";